// Vue
import {Vue, Component, Prop, Inject} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Col} from '../../col/Col'
import {Row} from '../../row/Row'

@Component({
    components: {
        Col,
        Row,
    },
    mixins: [template]
})
export class HeadInfoItem extends Vue {

    public get dtLabel() {
        if ( this.dt )
        {
            return this.dt + ":";
        }
        return '';
    }

    @Prop({type: [String, Number]})
    public dt!: string | number

    @Prop({type: [String, Number]})
    public dd!: string | number

    public created() {

    }

    public mounted() {

    }

    public destroyed() {

    }
}
